<template>
  <div class="row site-section-wrapper">
    <div class="col-4">
      <ProjectDetails/>
    </div>
    <div class="col-8 right-col">
      <ProjectMap/>
    </div>
  </div>
</template>
<script>
/* eslint-disable padded-blocks */
import { mapState } from 'vuex';
import ProjectMap from '@/components/projects/ProjectMap.vue';
import ProjectDetails from '@/components/projects/ProjectDetails.vue';

export default {
  name: 'ProjectOverview',
  components: {
    ProjectMap,
    ProjectDetails,
  },
  computed: {
    ...mapState('Project', {
      project: (state) => state.project,
    }),
  },
  mounted() {
    this.$store.dispatch('Project/getProject', parseInt(this.$route.params.id, 10));
  },
};
</script>
